import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import styles from "./holidays.module.css";
import { IoCloseSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Select from 'react-select';

export default function ModalHolidays(props) {
    const { show, setShow, handleUpdate, dataEdit, setDataEdit} = props;
    const [menuActive, setMenuActive] = useState("menu01");

    const [active,setActive] = useState(true);
    const [description,setDescription] = useState("");
    const [date,setDate] = useState(null); 

    const handleAgregar = () => {
        if (date === "" || description === "") {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            if (dataEdit != null) {
                let payload = {
                    id: dataEdit.id,
                    description: description,
                    status: active,
                    date: date
                }
                api(SERVICE.updateDiasFestivos, payload, "PUT")
                    .then((data) => {
                        let response = data.data;
                            if (response.status) {
                                handleUpdate();
                                setShow(false);
                                Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: "Guardado correctamente",
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                            }
                            else {
                                Swal.fire({
                                    title: response.generalMessage,
                                    icon: 'error',
                                    confirmButtonText: 'Aceptar'
                                })
                            }
                        


                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
            else {
               let payload = {
                    description: description,
                    status: active,
                    date: date
                }
                api(SERVICE.setDiasFestivos, payload, "POST")
                    .then((data) => {
                        let response = data.data;
                        if (response.status) {
                            handleUpdate();
                            setShow(false);
                            Swal.fire({
                                position: "center",
                                icon: "success",
                                title: "Guardado correctamente",
                                showConfirmButton: false,
                                timer: 1500
                            });
                        }
                        else {
                            Swal.fire({
                                title: response.generalMessage,
                                icon: 'error',
                                confirmButtonText: 'Aceptar'
                            })
                        }

                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }

        }

    }

    useEffect(() => {
        if (!show) {
            setDate("");
            setDescription("");
            setActive(true);
            setDataEdit(null);
            setMenuActive("menu01")
        }else{
             if (dataEdit != null) {
                setDescription(dataEdit.description);
                setDate(dataEdit.date?dataEdit.date.split("T")[0]:"-");
                setActive(dataEdit.status);
            }
        }
    },[show,dataEdit])
    return (
        <>
            <div className={styles.bodyModal} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none" }}>
                    <div className={styles.headerForm}>
                        <h5>{dataEdit != null ? "Editar Dia Festivo" : "Nuevo Dia Festivo"}</h5>
                        <div className={styles.icon} onClick={() => setShow(false)}>
                            <IoCloseSharp />
                        </div>

                    </div>
                    <div className={styles.containerForm} style={{ display: menuActive == "menu01" ? "flex" : "none" }}>
                        <div className={styles.itemForm} style={{ width: "40%" }}>
                            <label class="form-label">Fecha</label>
                            <input type="date" data-date-format="DD MMMM YYYY" class="form-control" placeholder="" value={date} onChange={(e) => setDate(e.target.value)} />
                        </div>
                        <div className={styles.itemForm}>
                            <label class="form-label">Descripción</label>
                            <input type="text" class="form-control" placeholder="Descripción" value={description} onChange={(e) => setDescription(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ display: "flex", alignItems: "center", width: "35%" }}>
                            <input class="form-check-input" type="checkbox" role="switch" id="switchCheckChecked" checked={active} onChange={() => setActive(!active)} />
                            <label class="form-check-label" for="switchCheckChecked" style={{ fontWeight: "bold", color: active ? "green" : "red" }}>{active ? "Activo" : "Inactivo"}</label>
                        </div>
                    </div>
                   
                    <div className={styles.containerBtn}>
                        <button className='btn btn-success' onClick={handleAgregar}>{dataEdit != null ? "Guardar" : "Guardar"}</button>&nbsp;&nbsp;
                        <button className='btn btn-danger' onClick={() => setShow(false)}>Cancelar</button>
                    </div>
                </div>
            </div>
        </>
    );
}